import { StepType } from '.';

// ASSETS
import DairyImage from '@assets/svgs/klima/Icon_Molkerei.svg'
import DairyCowImage from '@assets/svgs/klima/Icon_Milchkuh.svg'
import HeiferImage from '@assets/svgs/klima/Icon_Farse.svg'
import CalfImage from '@assets/svgs/klima/Icon_Kalb.svg'
import DairyCowHusbandryImage from '@assets/svgs/klima/Icon_Haltung_Milchkuh.svg'
import CalfHusbandryImage from '@assets/svgs/klima/Icon_Haltung_Farse.svg'
import CowManureImage from '@assets/svgs/klima/Icon_Dunger_Milchkuh.svg'
import CalfManureImage from '@assets/svgs/klima/Icon_Dunger_Farse.svg'
import CowEnergyImage from '@assets/svgs/klima/Icon_Energie_Milchkuh.svg'
import CalfEnergyImage from '@assets/svgs/klima/Icon_Energie_Farse.svg'
import PerformanceImage from '@assets/svgs/klima/Icon_Leistungsgruppe.svg'
import CowFeedImage from '@assets/svgs/klima/Icon_Futter_Milchkuh.svg'
import CalfFeedImage from '@assets/svgs/klima/Icon_Futter_Farse.svg'
import AdditivesImage from '@assets/svgs/klima/Icon_Zusatzstoffe.svg'
import ResultsImage from '@assets/svgs/klima/Icon_Ergebnis.svg'
import LandUseImage from '@assets/svgs/klima/Icon_Landnutzung.svg'
import ForageImage from '@assets/svgs/klima/futterbau.jpg'
import HayBale from '@assets/svgs/hay-bale.svg'

export enum StepId {
  DAIRY_DATA = 'dairy_data',
  DAIRY_COW_METRICS = 'dairy_cow_metrics',
  HEIFER_METRICS = 'heifer_metrics',
  CALF_REARING = 'calf_rearing',
  DAIRY_COW_HUSBANDRY = 'dairy_cow_husbandry',
  HEIFER_HUSBANDRY = 'heifer_husbandry',
  DAIRY_COW_MANURE = 'dairy_cow_manure',
  HEIFER_MANURE = 'heifer_manure',
  DAIRY_COW_ENERGY = 'dairy_cow_energy',
  HEIFER_ENERGY = 'heifer_energy',
  FORAGE_PRODUCTION = 'forage_production',
  PERFORMANCE_GROUP = 'performance_group',
  DAIRY_COW_FEED = 'dairy_cow_feed',
  HEIFER_FEED = 'heifer_feed',
  FORAGE_FEEDS = 'forage_feeds',
  ADDITIVES_USAGE = 'additives_usage',
  LAND_USE = 'land_use',
  GHG_RESULT = 'ghg_result'
}

export const allSteps = [
  {
    id: StepId.DAIRY_DATA,
    title: 'Molkereidaten',
    image: DairyImage,
    style: { width: 35 }
  },
  {
    id: StepId.DAIRY_COW_METRICS,
    title: 'Kennzahlen Milchkuh',
    image: DairyCowImage,
    style: { marginTop: 16, width: 32 }
  },
  {
    id: StepId.HEIFER_METRICS,
    title: 'Kennzahlen Färsen',
    image: HeiferImage,
    style: { marginTop: 16, width: 32 }
  },
  {
    id: StepId.CALF_REARING,
    title: 'Kälberaufzucht',
    image: CalfImage,
    style: { marginTop: 16, width: 32 }
  },
  {
    id: StepId.DAIRY_COW_HUSBANDRY,
    title: 'Haltungssystem Milchkuh',
    image: DairyCowHusbandryImage,
    style: { marginTop: 16, width: 32 }
  },
  {
    id: StepId.HEIFER_HUSBANDRY,
    title: 'Haltungssystem Färse',
    image: CalfHusbandryImage,
    style: { marginTop: 16, width: 32 },
    calfStep: true
  },
  {
    id: StepId.DAIRY_COW_MANURE,
    title: 'Wirtschaftsdünger Milchkuh',
    image: CowManureImage,
    style: { marginTop: 16, width: 32 }
  },
  {
    id: StepId.HEIFER_MANURE,
    title: 'Wirtschaftsdünger Färse',
    image: CalfManureImage,
    style: { marginTop: 16, width: 32 },
    calfStep: true
  },
  {
    id: StepId.DAIRY_COW_ENERGY,
    title: 'Energie Milchkuh',
    image: CowEnergyImage,
    style: { marginTop: 16, width: 32 }
  },
  {
    id: StepId.HEIFER_ENERGY,
    title: 'Energie Färse',
    image: CalfEnergyImage,
    style: { marginTop: 16, width: 32 },
    calfStep: true
  },
  {
    id: StepId.FORAGE_PRODUCTION,
    title: 'Futterbau',
    image: HayBale,
    style: { marginTop: 16, width: 32, borderRadius: '50%', transform: 'scale(1.3)' },
    forageStep: true
  },
  {
    id: StepId.PERFORMANCE_GROUP,
    title: 'Leistungsgruppe (Milchkuh & Färse)',
    image: PerformanceImage,
    style: { marginTop: 16, width: 32 },
    feedGroupTab: true
  },
  {
    id: StepId.DAIRY_COW_FEED,
    title: 'Futterration Milchkuh',
    image: CowFeedImage,
    style: { marginTop: 16, width: 32 }
  },
  {
    id: StepId.HEIFER_FEED,
    title: 'Futterration Färse',
    image: CalfFeedImage,
    style: { marginTop: 16, width: 32 },
    calfStep: true
  },
  {
    id: StepId.FORAGE_FEEDS,
    title: 'Eigenanbau Futter',
    image: ForageImage,
    style: { marginTop: 16, width: 32, borderRadius: '50%', transform: 'scale(1.3)' },
    forageStep: true
  },
  {
    id: StepId.ADDITIVES_USAGE,
    title: 'Einsatz Zusatzstoffe',
    image: AdditivesImage,
    style: { marginTop: 16, width: 32 }
  },
  {
    id: StepId.LAND_USE,
    title: 'Landnutzung',
    image: LandUseImage,
    style: { marginTop: 16, width: 32 }
  },
  {
    id: StepId.GHG_RESULT,
    title: 'THG Ergebnis',
    image: ResultsImage,
    style: { marginTop: 16, width: 25 }
  }
] as StepType[]

export const heiferPhaseTypes = [
  {
    label: 'Individuell',
    key: 'individual'
  },
  {
    label: 'angelehnt an DLG-Fütterungsempfehlung',
    key: 'dlg'
  }
]

const currentYear = new Date().getFullYear();
export const years = Array.from({ length: currentYear - 2002 }, (_, index) => 2003 + index);